























import { Component, Prop, Vue } from "vue-property-decorator";
import VCard from "@/components/VCard.vue";

export type ResumeeItem = {
  description: string;
  text: string;
  icon: string;
};

@Component({ components: { VCard } })
export default class VResumeeCard extends Vue {
  @Prop({ default: () => "" }) readonly title!: string;
  @Prop({ default: () => true }) readonly showHeader!: boolean;
  @Prop({ default: () => [] }) readonly items!: ResumeeItem[];
}
